































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import BuilderDeviceHighlight from '@/components/builder/BuilderDeviceHighlight.vue'
import { LocaleMessage } from 'vue-i18n'

@Component({
  components: {
    BuilderDeviceHighlight,
  },
  computed: {
    ...mapGetters('builder', { appType: 'getAppType' })
  }
})
export default class BuilderDeviceProfileDetailsStub extends Vue {
  @Prop({ default: true, type: Boolean }) blur!: boolean

  @Prop({ required: true, type: String }) color!: string

  @Prop({ default: null }) avatar!: null | string | File

  @Prop({ type: String }) description!: string | null

  @Prop({ default: 0, type: Number }) followers!: number

  @Prop({ default: 0, type: Number }) posts!: number

  @Prop({ type: String }) highlight!: null | 'avatar' | 'decription' | 'statistics'

  appType!: string
  showFullDescription = false

  get formattedDescription(): string | LocaleMessage {
    return this.description ? this.description : this.textFollowMe
  }

  get avatarUrl(): string | null {
    if (!this.avatar) {
      return null
    }
    return this.avatar instanceof File ? URL.createObjectURL(this.avatar) : this.avatar
  }
  get grayscale(): string {
    return this.blur ? 'filter grayscale' : ''
  }
  get textFollowMe(): any {
    return  this.appType === 'TYPE_BLOGER' 
      ? this.$t('followMe') 
      : this.$t('followMeStore') 
  }
}
